import { useState } from 'react';
import TableHead from '@material-ui/core/TableHead';
import TableBody from '@material-ui/core/TableBody';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';

import CloseIcon from '@material-ui/icons/Close';
import CheckIcon from '@material-ui/icons/Check';
import MoreVertIcon from '@material-ui/icons/MoreVert';

import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';

import Editor from 'react-simple-code-editor';
import { highlight, languages } from 'prismjs/components/prism-core';

import { getDeviceClasses } from 'homey-lib';

import 'prismjs/components/prism-clike';
import 'prismjs/components/prism-javascript';
import 'prismjs/themes/prism.css';

import TableWithSearch from './TableWithSearch';

function Yes() {
  return <CheckIcon style={{ color: 'green' }} />;
}

function No() {
  return <CloseIcon style={{ color: 'red' }} />;
}

const deviceClasses = getDeviceClasses();

function DeviceClassReference() {
  const [dialog, setDialog] = useState({ open: false, title: '', content: '' });
  const [filterValue, setFilterValue] = useState('');

  function handleClose() {
    setDialog({ open: false, title: '', content: '' });
  }

  return (
    <>
      <TableWithSearch
        filter={filterValue}
        onSearch={(deviceClassesFilter) => setFilterValue(deviceClassesFilter)}
      >
        <TableHead>
          <TableRow>
            <TableCell>ID</TableCell>
            <TableCell>Name</TableCell>
            <TableCell>Compatibility</TableCell>
            <TableCell>Description</TableCell>
            <TableCell>Allows Virtual</TableCell>
            <TableCell></TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {Object.keys(deviceClasses)
            .filter((deviceClassId) => {
              const deviceClass = deviceClasses[deviceClassId];
              return (JSON.stringify(deviceClass) + deviceClassId)
                .toLowerCase()
                .includes(filterValue.toLowerCase());
            })
            .map((deviceClassId) => {
              const deviceClass = deviceClasses[deviceClassId];
              return (
                <TableRow key={deviceClassId}>
                  <TableCell className={`CapabilityType`}>{deviceClassId}</TableCell>
                  <TableCell>{deviceClass.title.en}</TableCell>
                  <TableCell><code>{deviceClass.minCompatibility ? '>=' + deviceClass.minCompatibility : ''}</code></TableCell>
                  <TableCell>{deviceClass.description.en}</TableCell>
                  <TableCell>{deviceClass.allowedVirtual ? <Yes /> : <No />}</TableCell>
                  <TableCell>
                    <IconButton
                      onClick={() => {
                        setDialog({
                          open: true,
                          title: `Device Class — ${deviceClassId}`,
                          content: JSON.stringify(deviceClass, false, 2),
                        });
                      }}
                    >
                      <MoreVertIcon />
                    </IconButton>
                  </TableCell>
                </TableRow>
              );
            })}
        </TableBody>
      </TableWithSearch>

      <Dialog open={dialog.open} onClose={handleClose} fullWidth maxWidth={false}>
        <DialogTitle>{dialog.title}</DialogTitle>
        <DialogContent>
          <Editor
            value={dialog.content}
            highlight={(code) => code && highlight(code, languages.js)}
            style={{
              fontFamily: '"Fira code", "Fira Mono", monospace',
              fontSize: 12,
              outline: 'none',
            }}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Close</Button>
        </DialogActions>
      </Dialog>
    </>
  );
}

export default DeviceClassReference;
